<template lang="pug">
el-container
  el-header(height="auto")
    el-form(ref="form" label-suffix=":")
      el-col(:span="24")
        el-form-item(label="车辆信息" style="width:100%")
          el-input(
            v-model="form.plateNumber"
            placeholder="请输入车辆牌照号"
            maxlength="8"
            clearable
            style="width: 172px"
          )
      el-col(:span="24")
        el-form-item(label="司机信息" style="width:100%")
          el-select(
            v-model="form.userQueryType"
            placeholder="选择查询条件"
            style="margin-right:12px;width:120px"
            @change="form.userQueryValue = ''"
          )
            el-option(:value="1" label="手机号")
            el-option(:value="2" label="身份证号")
          el-input(
            v-model="form.userQueryValue"
            :placeholder="setPlaceHolder"
            :maxlength="maxLength"
            style="width:268px"
            clearable
          )
      el-col(:span="24")
        el-form-item
          el-button(type="primary" :loading="isLoading" @click="search")
            | 查询
          el-button(type="warning" @click="reset")
            | 重置
  el-main
    grid(
      :remoteMethod="getTableData"
      ref="grid"
      layout="prev, pager, next, jumper"
    )
      el-table-column(label="车牌号" align="center" prop="plateNumber")
      el-table-column(label="司机" align="center" min-width="150%")
        template(slot-scope="scope")
          p {{ scope.row.driverName }}
          p {{ scope.row.driverIdCard }}
          p {{ scope.row.driverPhone }}
      el-table-column(label="车主姓名" align="center" min-width="150%")
        template(slot-scope="scope")
          p {{ scope.row.driverName }}
      el-table-column(label="车型信息" align="center" prop="vehicleType")
      el-table-column(label="车身颜色" align="center" prop="vehicleColor")
      el-table-column(label="操作")
        template(slot-scope="scope")
          el-button(type="text" @click="() => clickDetail(scope.row)") 详情

</template>
<script>
import moment from 'moment';
import grid from '@/components/grid';
import deepCopy from '@/utils/deepCopy';
import { getDriverList } from '@/api/hitch';
import AmapSelector from '@/components/AmapSelector';

const now = moment().format('YYYY-MM-DD 00:00:00');
const start = moment(now).add(-6, 'days').format('YYYY-MM-DD 00:00:00');
const end = moment().format('YYYY-MM-DD 23:59:59');
const rangeTimeStart = moment(now).add(-119, 'days');
const rangeTimeEnd = moment(now);
const defaultForm = {
  timeType: 1,
  timeRange: [
    start, end,
  ],
  userType: 2,
  userQueryType: 1,
  posType: 1,
};

export default {
  name: 'HitchInfoVehicles',
  components: {
    grid,
    AmapSelector
  },
  filters: {
    dateFormat(val) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  data() {
    return {
      dialogVisible: false,
      isLoading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < rangeTimeStart || time.getTime() > rangeTimeEnd;
        }
      },
      form: deepCopy(defaultForm),
      provinceList: [],
      cityList: [],
    };
  },
  computed: {
    setPlaceHolder() {
      const placeholderMap = {
        1: '请输入手机号',
        2: '请输入身份证号'
      };
      return placeholderMap[this.form.userQueryType];
    },
    maxLength() {
      const maxLengthMap = {
        1: '11',
        2: '18'
      };
      return maxLengthMap[this.form.userQueryType];
    }
  },
  mounted() {

  },
  methods: {
    clickDetail(item) {
      this.$router.push({
        name: 'hitchInfoVehicle',
        query: {
          newId: item.driverNewId,
          driverIdCard: item.driverIdCard,
        },
      });// 跳转详情页面
    },
    getParams() {
      const {
        userQueryType,
        userQueryValue,

        plateNumber,
      } = this.form;
      const result = {
        plateNumber,
      };

      if (userQueryType === 1) {
        result.driverMobile = userQueryValue;
      } else if (userQueryType === 2) {
        result.driverIdCard = userQueryValue;
      }
      return result;
    },
    search() {
      const {
        timeRange,
        userQueryValue,
        provinceCode,
        cityCode,
        plateNumber,
      } = this.form;
      // 判断查询条件是否为空
      if ((!timeRange || !timeRange[0] || !timeRange[1]) &&
      !userQueryValue && !provinceCode && !cityCode && !plateNumber) {
        this.$message.error('请选择至少一项查询条件');
        return;
      }

      this.$refs.grid.loadData(this.getParams());
    },
    reset() {
      this.form = deepCopy(defaultForm);
      this.$refs.grid.reset();
    },
    async getTableData(params) {
      const {
        page,
        rows,
        ...restParms
      } = params;
      restParms.startPage = page - 1;
      restParms.pageSize = rows;
      const { data } = await getDriverList(restParms);
      return { data: data.list, total: data.total };
    },
  }
};
</script>


<style lang="less" scoped>
</style>




// WEBPACK FOOTER //
// src/views/info/hitch/vehicles.vue?9bbe11fe